import {useNavigate, useParams} from "react-router-dom"
import {useTranslation} from "react-i18next"

import {PaymentOption} from "./PaymentOption"

import {useAnalytics} from "@indebted/analytics"

function PaymentPlanOptionLink({RequiresAffordabilityAssessment}: {RequiresAffordabilityAssessment: boolean}) {
	const {t} = useTranslation()
	const {secureCode} = useParams()
	const {track} = useAnalytics()
	const navigate = useNavigate()

	return (
		<PaymentOption
			Type="PaymentPlan"
			onClick={() => {
				track("PPButtonClicked", {SecureCode: secureCode})
				if (RequiresAffordabilityAssessment) {
					navigate(`/${secureCode}/affordability-assessment/payment-plan/initiate`)
				} else {
					navigate(`/${secureCode}/payment-plan`)
				}
			}}
			Title={t("customer_get.outstanding_balance.paymentplan.create_payment_plan")}
			Description={t("customer_get.outstanding_balance.paymentplan.split_up_payments")}
		/>
	)
}

export {PaymentPlanOptionLink}
